import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

// Initialize pdfMake with fonts
pdfMake.vfs = pdfFonts;

function formatCurrency(value) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
}

function checkNull(str) {
    if (str == null) {
        return '';
    } else {
        return str;
    }
}

export function generateInvoicePdf(invoiceData) {
    return new Promise((resolve, reject) => {
        try {
            const { header, details, client, docs } = invoiceData;
            const invTotal = header.Subtotal;

            const formatDate = (dateTime) => {
                if (!dateTime) return '';
                const date = new Date(dateTime);
                return date.toLocaleDateString('en-US');
            };

            const dd = {
                content: [
                    {
                        columns: [
                            {
                                width: '*',
                                text: [
                                    { text: checkNull(client.Name), style: 'header' },
                                    { text: '\n' },
                                    { text: checkNull(client.Address), style: 'subheader' },
                                    { text: '\n' },
                                    { text: `${checkNull(client.City)}, ${checkNull(client.State)} ${checkNull(client.Zip)}`, style: 'subheader' },
                                    { text: '\n' },
                                    { text: checkNull(client.Phone), style: 'subheader' }
                                ]
                            },
                            {
                                width: 'auto',
                                text: [
                                    { text: 'INVOICE', style: 'invoiceTitle' },
                                    { text: '\n' },
                                    { text: `Invoice Number: ${header.RefNumber}`, style: 'invoiceInfo' },
                                    { text: '\n' },
                                    { text: `Invoice Date: ${formatDate(header.TimeCreated)}`, style: 'invoiceInfo' },
                                    { text: '\n' },
                                    { text: `Due Date: ${formatDate(header.DueDate)}`, style: 'invoiceInfo' },
                                    { text: '\n' },
                                    { text: `PO: ${checkNull(header.PONumber)}`, style: 'invoiceInfo' },
                                ]
                            }
                        ]
                    },
                    {
                        text: 'Bill To:',
                        style: 'billTo'
                    },
                    {
                        text: checkNull(header.Customer_FullName),
                        style: 'customerDetails'
                    },
                    {
                        style: 'tableContainer',
                        table: {
                            headerRows: 1,
                            widths: ['*', 'auto', 'auto', 'auto'],
                            body: [
                                [
                                    { text: 'Description', style: 'tableHeader' },
                                    { text: 'Qty', style: 'tableHeader' },
                                    { text: 'Price', style: 'tableHeader' },
                                    { text: 'Total', style: 'tableHeader' }
                                ],
                                ...details
                                    .filter(item => {
                                        // Filter out items where description is empty/null AND rate is 0
                                        const description = item.Descrip || item.Description || '';
                                        const rate = item.Rate || 0;
                                        return !(description.trim() === '' && rate === 0);
                                    })
                                    .map(item => [
                                        { text: checkNull(item.Descrip || item.Description), style: 'tableData' },
                                        { text: invTotal !== 0 && item.Quantity === 0 ? 1 : item.Quantity, style: 'tableData', alignment: 'right' },
                                        { text: formatCurrency(item.Rate), style: 'tableData', alignment: 'right' },
                                        { text: formatCurrency(item.Rate * (invTotal !== 0 && item.Quantity === 0 ? 1 : item.Quantity)), style: 'tableData', alignment: 'right' }
                                    ])
                            ]
                        },
                        layout: 'lightHorizontalLines'
                    },
                    {
                        columns: [
                            { width: '*', text: '' },
                            {
                                width: 'auto',
                                table: {
                                    body: [
                                        [
                                            { text: 'Total', style: 'totalLabel' },
                                            { text: formatCurrency(
                                                details
                                                    .filter(item => {
                                                        // Same filter as above - exclude empty description + zero rate items
                                                        const description = item.Descrip || item.Description || '';
                                                        const rate = item.Rate || 0;
                                                        return !(description.trim() === '' && rate === 0);
                                                    })
                                                    .reduce((sum, item) => sum + (item.Rate * (invTotal !== 0 && item.Quantity === 0 ? 1 : item.Quantity)), 0)
                                            ), style: 'totalValue', alignment: 'right' }
                                        ],
                                    ]
                                },
                                layout: 'noBorders'
                            }
                        ]
                    }
                ],
                styles: {
                    header: {
                        fontSize: 18,
                        bold: true,
                        margin: [0, 0, 0, 5]
                    },
                    subheader: {
                        fontSize: 12,
                        margin: [0, 0, 0, 2]
                    },
                    invoiceTitle: {
                        fontSize: 22,
                        bold: true,
                        alignment: 'right',
                        margin: [0, 0, 0, 10]
                    },
                    invoiceInfo: {
                        fontSize: 10,
                        alignment: 'right',
                        margin: [0, 0, 0, 2]
                    },
                    billTo: {
                        fontSize: 14,
                        bold: true,
                        margin: [0, 20, 0, 5]
                    },
                    customerDetails: {
                        fontSize: 12,
                        margin: [0, 0, 0, 15]
                    },
                    tableContainer: {
                        margin: [0, 10, 0, 10]
                    },
                    tableHeader: {
                        bold: true,
                        fontSize: 12,
                        color: 'black',
                        fillColor: '#f5f5f5'
                    },
                    tableData: {
                        margin: [0, 2, 0, 2],
                        fontSize: 8
                    },
                    totalLabel: {
                        bold: true,
                        fontSize: 12,
                        margin: [0, 2, 0, 2]
                    },
                    totalValue: {
                        fontSize: 12,
                        margin: [0, 2, 0, 2]
                    }
                }
            };

            pdfMake.createPdf(dd).getDataUrl(function (dataUrl) {
                resolve({
                    dataUrl,
                    docs: docs?.data?.docs || []
                });
            });
        } catch (error) {
            reject(error);
        }
    });
} 